var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
export var selectAll = function (options) {
    var advancedFilterValue = [];
    return options.cols.reduce(function (advancedFilterValue, column) {
        var groupData = [];
        column.groups.forEach(function (_a) {
            var items = _a.items;
            groupData.push.apply(groupData, items.map(function (_a) {
                var value = _a.value;
                return value;
            }));
        });
        return __spreadArrays(advancedFilterValue, groupData);
    }, advancedFilterValue);
};
//# sourceMappingURL=selectAll.js.map